// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-urgency-badge":"ListingFigureMainImage_hz-Listing-urgency-badge__1qyct","hz-Badge":"ListingFigureMainImage_hz-Badge__rcR3Y"};